export {
  getAlphasCount,
  getDigitsCount,
};

function getAlphasCount(value: string): number {
  const alphas = value.match(/[a-zA-Z]/g);

  if (Array.isArray(alphas)) {
    return alphas.length;
  }
  return 0;
}

function getDigitsCount(value: string): number {
  const digits = value.match(/\d/g);

  if (Array.isArray(digits)) {
    return digits.length;
  }
  return 0;
}
